module.exports = __webpack_public_path__ + "static/img/10.17a6775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/10.jpg
// module id = hMqw
// module chunks = 1